import queries from '@apis/queries';
import { EventRow } from '@models/event';
import { GetEventsParams } from '@models/event/request';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

function useEvents() {
  const [page, setPage] = useState<number>(0);
  const params: GetEventsParams = {
    page, size: 5, sorter: 'CreatedAtDesc',
  };
  const [events, setEvents] = useState<EventRow[]>([]);
  const { data, status } = useQuery(queries.events.list(params));
  const isLoading = status === 'pending';
  const isBlank = !isLoading && events.length === 0;
  const fetchNextPage = () => {
    if (data && !data.page.isLast && status === 'success') {
      setPage((prev) => prev + 1);
    }
  };
  useEffect(() => {
    if (data) {
      setEvents((prev) => [...prev, ...data.content]);
    }
  }, [data]);
  return {
    events, fetchNextPage, isLoading, isBlank,
  };
}

export default useEvents;
